import {
  ItemTypeChecker,
  isAgentJoinedEvent,
  isAgentLeftEvent,
  isIncomingMessage,
  isOutgoingMessage,
  isTriggerMessage,
  shouldSendReceipt,
  isQueueTriggerMessage
} from './itemCheckers';

type ChatTranscriptItem = connect.ChatTranscriptItem;

export const withoutTriggeringMessages = (transcript: ChatTranscriptItem[]): ChatTranscriptItem[] => {
  // Filter out from the transcript "triggering" messages that the back-end requires
  // but should not be seen by the user.
  return transcript.filter(item => !isTriggerMessage(item));
};

export const customerMessageCount = (transcript: ChatTranscriptItem[]): number => {
  return withoutTriggeringMessages(transcript).filter(isOutgoingMessage).length;
};

export const searchTranscriptForItem = (
  transcript: ChatTranscriptItem[],
  itemMatcher: ItemTypeChecker
): ChatTranscriptItem | undefined => {
  for (let i = transcript.length - 1; i >= 0; i -= 1) {
    const item = transcript[i];
    if (itemMatcher(item)) {
      return item;
    }
  }
  return undefined;
};

export const findLastIncomingMessage = (transcript: ChatTranscriptItem[]): ChatTranscriptItem | undefined => {
  return searchTranscriptForItem(transcript, isIncomingMessage);
};

export const findLastReceiptableMessage = (transcript: ChatTranscriptItem[]): ChatTranscriptItem | undefined => {
  return searchTranscriptForItem(transcript, shouldSendReceipt);
};

export const isAgentParticipating = (transcript: ChatTranscriptItem[]): boolean | undefined => {
  const checker: ItemTypeChecker = item => isAgentJoinedEvent(item) || isAgentLeftEvent(item);

  const agentEvent = searchTranscriptForItem(transcript, checker);

  return agentEvent && isAgentJoinedEvent(agentEvent);
};

export const isWaitingForAgentToJoin = (transcript: ChatTranscriptItem[]): boolean | undefined => {
  // Check whether there is queue trigger message (waiting for agent)
  const waitingForAgentMessage = searchTranscriptForItem(transcript, isQueueTriggerMessage);

  return !!waitingForAgentMessage;
};
